/**
 * 功能 - 封装axios
 */
import axios from 'axios'
import { Message } from 'element-ui'
import { urls } from './allapi.js'
/*eslint-disable*/
const Axios = axios.create()
Axios.defaults.baseURL = urls;
Axios.defaults.timeout = 300 * 1000
Axios.defaults.headers['Content-Type'] = 'application/json'

Axios.defaults.transformRequest = [data => (typeof (data) === 'object' ? JSON.stringify(data) : data)]


// 请求拦截
Axios.interceptors.request.use(config => {
    const token = localStorage.getItem('accessToken');
    console.log("token值");
    console.log(token);
    // 其实可以用路由守卫或者promise来获取vue当前路由，但是这里选择用window.location简单粗暴
    if (token && window.location.pathname !== '/login') {
        config.headers.common['Authorization'] = token;
    }
    return config
}, err => {
    Message.error('请求超时!')
    return Promise.reject(err)
})

// 响应拦截
Axios.interceptors.response.use(res => {
    //  alert("响应拦截");
    console.log("响应拦截");
     console.log(res);
    console.log("响应拦截..");
    // 特殊情况，导出
    if (res.status == 200 && !res.data.data && !res.data.code) {
        return res.data
    }
    if (res.data.code === '3001') {
        return res.data
    }
    if (res.data.code == "0000" || res.data.code == 201) {
        return res.data.data
    } else if(res.data.code == "200") {
        return res.data
    } else if (res.data.code == 1100) {
        //alert(res.data.code);
        sessionStorage.setItem('beOverdue', true)
         window.$bus.$router.push({ path: '/login' })
    } else {
        // console.log(this)
        Message.error(res.data.msg)
        // return res.data
    }

}, error => {
   // alert(error.response.data)
    console.log("error.response.data");
    console.log(error.response);
    console.log("error.response.data");
   // console.log(error.response.data)
    if (error.response.status == '500' && error.response.data.message == "尚未登录") {
        //  alert(error.response.status);
    } else
    {
        Message.error('服务器异常');
    }
    console.log("响应错误");
    console.log(error);
    console.log("响应错误..");

    return Promise.reject(error)
})



export default Axios
